import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

import ClaimsUDA from "./claims/uda";
import ClaimsSend from "./claims/send";
import ClaimsValidate from "./claims/validate";
import ClaimsHold from "./claims/hold";
import ClaimsSchedules from "./claims/schedules";
import ClaimsSent from "./claims/sent";
import ClaimsAck from "./claims/acknowledgements";

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabBar: {
    boxShadow: 'none',
    backgroundColor: '#eaeaea',
    color: 'black',
  }
});

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

class ClaimsAdmin extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
    }

    state = {
        value: 0,
    };

    handleChange = (event, value) => {
        this.setState({ value });
    };

    tabSelector = (value) => {
        this.setState({value});
    }    

    render() {
        const { classes } = this.props;
        const { value } = this.state;

        let tabProps = {
            socket:this.props.socket,
            setTab:this.tabSelector
        }

        return (
        <div>
            <AppBar position="static" className={classes.tabBar}>
            <Tabs value={value} onChange={this.handleChange} 
                variant="scrollable" scrollButtons="auto" indicatorColor="primary">
                <Tab label="UDA Monitor"/>
                <Tab label="Claims to Send"/>
                <Tab label="Claims to Validate"/>
                <Tab label="Claims on Hold"/>
                <Tab label="Acknowledgements"/>
                <Tab label="Schedules"/>
                <Tab label="Sent Claims"/>
            </Tabs>
            </AppBar>     
            {value === 0 && <TabContainer><ClaimsUDA {...tabProps}/></TabContainer>}
            {value === 1 && <TabContainer><ClaimsSend {...tabProps}/></TabContainer>}
            {value === 2 && <TabContainer><ClaimsValidate {...tabProps}/></TabContainer>}
            {value === 3 && <TabContainer><ClaimsHold {...tabProps}/></TabContainer>}
            {value === 4 && <TabContainer><ClaimsAck {...tabProps}/></TabContainer>}
            {value === 5 && <TabContainer><ClaimsSchedules {...tabProps}/></TabContainer>}
            {value === 6 && <TabContainer><ClaimsSent {...tabProps}/></TabContainer>}
        </div>
        );
    }
}

export default withStyles(styles)(ClaimsAdmin);